exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Cards .block{display:flex;flex-direction:column;position:relative}.Cards .block .spinner{width:100%;position:absolute;align-items:center;justify-content:center;display:flex;background:hsla(0,0%,100%,.4);z-index:999;height:100%;min-height:400px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/Card/components/Cards/style.scss
// module id = 5129
// module chunks = 0